import React, { useState, useEffect } from "react";
// Component
import UserLogin from "./Component/UserLogin";
import CollaboratorLogin from "./Component/CollaboratorLogin";
import CustomerLogin from "./Component/CustomerLogin";
import { Link, useLocation } from "react-router-dom";
// Redux
import { useDispatch } from "react-redux";
import { LOGOUT } from "../../redux/constants";

const Login = ({ user, setUser }) => {
  const [tabs, setTabs] = useState(1);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch({ type: LOGOUT });
    localStorage.clear();
  }, []);

  useEffect(() => {
    if (location.state?.type && location.state?.type === "customer") setTabs(3);
  }, []);

  return (
    <main className="bg-white h-screen relative md:flex">
      {/* Image */}
      <div className="hidden md:block md:w-1/2" aria-hidden="true">
        <img
          className="object-cover object-center w-full h-full"
          src={require("../../assets/img/login-image.jpeg")}
          width="760"
          height="1024"
          alt="Authentication"
        />
      </div>
      {/* Content */}
      <div className="min-h-full md:w-1/2 after:flex-1">
        <div className="max-w-sm mx-auto h-[100vh] flex items-center">
          <div className="px-4 py-8 w-full">
            {/* Header */}
            <div className="flex flex-1 mb-5">
              <div className="flex items-center">
                {/* Logo */}
                <div className="block w-[40px]">
                  <img
                    alt="Logo"
                    src={require("../../assets/img/ShiproneLogo.png")}
                  />
                </div>
              </div>
            </div>
            <h1 className="text-3xl text-slate-800 font-bold mb-6">
              Sign into your account
            </h1>

            {/* Login as Tabs */}
            <div className="space-y-2 mb-8">
              <h3 className="text-base leading-5 font-medium tracking-tight text-[#535860]">
                Login as
              </h3>
              <div className="bg-[--bg-color-50] rounded grid grid-cols-3">
                <div
                  className={`text-sm font-medium leading-4 tracking-tight rounded p-1 text-center cursor-pointer ${
                    tabs === 1 && "bg-indigo-500 text-white"
                  }`}
                  onClick={() => setTabs(1)}
                >
                  User
                </div>
                <div
                  className={`text-sm font-medium leading-4 tracking-tight rounded p-1 text-center cursor-pointer ${
                    tabs === 2 && "bg-indigo-500 text-white"
                  }`}
                  onClick={() => setTabs(2)}
                >
                  Collaborator
                </div>
                <div
                  className={`text-sm font-medium leading-4 tracking-tight rounded p-1 text-center cursor-pointer ${
                    tabs === 3 && "bg-indigo-500 text-white"
                  }`}
                  onClick={() => setTabs(3)}
                >
                  Customer
                </div>
              </div>
            </div>

            {/* Form for Tab 1*/}
            {tabs === 1 && <UserLogin />}
            {tabs === 2 && <CollaboratorLogin />}
            {tabs === 3 && <CustomerLogin />}

            {/* Footer */}
            <div className="pt-5 mt-6 border-t border-slate-200">
              <div className="text-sm">
                Don't you have an account?{" "}
                <Link
                  to="/signup"
                  // href="https://shiperone.com/pricing-plans"
                  className="font-medium text-indigo-500 hover:text-indigo-500 hover:underline"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
